// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/connector.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { ResourceType } from "./resource";
import { Struct } from "../../../google/protobuf/struct";
import { AssetRef } from "./asset";
import { Any } from "../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceCleanupRequest
 */
export interface ConnectorServiceCleanupRequest {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 2;
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceCleanupResponse
 */
export interface ConnectorServiceCleanupResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1;
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorMetadata
 */
export interface ConnectorMetadata {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string help_url = 2;
     */
    helpUrl: string;
    /**
     * @generated from protobuf field: c1.connector.v2.AssetRef icon = 3;
     */
    icon?: AssetRef;
    /**
     * @generated from protobuf field: c1.connector.v2.AssetRef logo = 4;
     */
    logo?: AssetRef;
    /**
     * @generated from protobuf field: google.protobuf.Struct profile = 5;
     */
    profile?: Struct;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 6;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string description = 7;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.connector.v2.ConnectorCapabilities capabilities = 8;
     */
    capabilities?: ConnectorCapabilities;
    /**
     * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema account_creation_schema = 9;
     */
    accountCreationSchema?: ConnectorAccountCreationSchema;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialDetails
 */
export interface CredentialDetails {
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialDetailsAccountProvisioning capability_account_provisioning = 1;
     */
    capabilityAccountProvisioning?: CredentialDetailsAccountProvisioning;
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialDetailsCredentialRotation capability_credential_rotation = 2;
     */
    capabilityCredentialRotation?: CredentialDetailsCredentialRotation;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialDetailsAccountProvisioning
 */
export interface CredentialDetailsAccountProvisioning {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options = 1;
     */
    supportedCredentialOptions: CapabilityDetailCredentialOption[];
    /**
     * @generated from protobuf field: c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option = 2;
     */
    preferredCredentialOption: CapabilityDetailCredentialOption;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialDetailsCredentialRotation
 */
export interface CredentialDetailsCredentialRotation {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.CapabilityDetailCredentialOption supported_credential_options = 1;
     */
    supportedCredentialOptions: CapabilityDetailCredentialOption[];
    /**
     * @generated from protobuf field: c1.connector.v2.CapabilityDetailCredentialOption preferred_credential_option = 2;
     */
    preferredCredentialOption: CapabilityDetailCredentialOption;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorCapabilities
 */
export interface ConnectorCapabilities {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.ResourceTypeCapability resource_type_capabilities = 1;
     */
    resourceTypeCapabilities: ResourceTypeCapability[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Capability connector_capabilities = 2;
     */
    connectorCapabilities: Capability[];
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialDetails credential_details = 3;
     */
    credentialDetails?: CredentialDetails;
}
/**
 * @generated from protobuf message c1.connector.v2.CapabilityPermission
 */
export interface CapabilityPermission {
    /**
     * @generated from protobuf field: string permission = 1;
     */
    permission: string;
}
/**
 * @generated from protobuf message c1.connector.v2.CapabilityPermissions
 */
export interface CapabilityPermissions {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.CapabilityPermission permissions = 1;
     */
    permissions: CapabilityPermission[];
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceTypeCapability
 */
export interface ResourceTypeCapability {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceType resource_type = 1;
     */
    resourceType?: ResourceType;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Capability capabilities = 2;
     */
    capabilities: Capability[];
    /**
     * @generated from protobuf field: c1.connector.v2.CapabilityPermissions permissions = 3;
     */
    permissions?: CapabilityPermissions;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceGetMetadataRequest
 */
export interface ConnectorServiceGetMetadataRequest {
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceGetMetadataResponse
 */
export interface ConnectorServiceGetMetadataResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.ConnectorMetadata metadata = 1;
     */
    metadata?: ConnectorMetadata;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorServiceValidateRequest
 */
export interface ConnectorServiceValidateRequest {
}
/**
 * NOTE(morgabra) We're expecting correct grpc.Status responses
 * for things like 401/403/500, etc
 *
 * @generated from protobuf message c1.connector.v2.ConnectorServiceValidateResponse
 */
export interface ConnectorServiceValidateResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1;
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string sdk_version = 2;
     */
    sdkVersion: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema
 */
export interface ConnectorAccountCreationSchema {
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> field_map = 1;
     */
    fieldMap: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.Field
 */
export interface ConnectorAccountCreationSchema_Field {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool required = 2;
     */
    required: boolean;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string placeholder = 4;
     */
    placeholder: string;
    /**
     * @generated from protobuf field: int32 order = 5;
     */
    order: number;
    /**
     * @generated from protobuf field: bool deprecated = 6;
     */
    deprecated: boolean;
    /**
     * @generated from protobuf oneof: field
     */
    field: {
        oneofKind: "stringField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.StringField string_field = 100;
         */
        stringField: ConnectorAccountCreationSchema_StringField;
    } | {
        oneofKind: "boolField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.BoolField bool_field = 101;
         */
        boolField: ConnectorAccountCreationSchema_BoolField;
    } | {
        oneofKind: "stringListField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.StringListField string_list_field = 102;
         */
        stringListField: ConnectorAccountCreationSchema_StringListField;
    } | {
        oneofKind: "intField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.IntField int_field = 103;
         */
        intField: ConnectorAccountCreationSchema_IntField;
    } | {
        oneofKind: "mapField";
        /**
         * @generated from protobuf field: c1.connector.v2.ConnectorAccountCreationSchema.MapField map_field = 104;
         */
        mapField: ConnectorAccountCreationSchema_MapField;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringField
 */
export interface ConnectorAccountCreationSchema_StringField {
    /**
     * @generated from protobuf field: optional string default_value = 1;
     */
    defaultValue?: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.BoolField
 */
export interface ConnectorAccountCreationSchema_BoolField {
    /**
     * @generated from protobuf field: optional bool default_value = 1;
     */
    defaultValue?: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringListField
 */
export interface ConnectorAccountCreationSchema_StringListField {
    /**
     * @generated from protobuf field: repeated string default_value = 1;
     */
    defaultValue: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.IntField
 */
export interface ConnectorAccountCreationSchema_IntField {
    /**
     * @generated from protobuf field: optional int32 default_value = 1;
     */
    defaultValue?: number;
}
/**
 * @generated from protobuf message c1.connector.v2.ConnectorAccountCreationSchema.MapField
 */
export interface ConnectorAccountCreationSchema_MapField {
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.ConnectorAccountCreationSchema.Field> default_value = 1;
     */
    defaultValue: {
        [key: string]: ConnectorAccountCreationSchema_Field;
    };
}
/**
 * @generated from protobuf enum c1.connector.v2.Capability
 */
export enum Capability {
    /**
     * @generated from protobuf enum value: CAPABILITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CAPABILITY_PROVISION = 1;
     */
    PROVISION = 1,
    /**
     * @generated from protobuf enum value: CAPABILITY_SYNC = 2;
     */
    SYNC = 2,
    /**
     * @generated from protobuf enum value: CAPABILITY_EVENT_FEED = 3;
     */
    EVENT_FEED = 3,
    /**
     * @generated from protobuf enum value: CAPABILITY_TICKETING = 4;
     */
    TICKETING = 4,
    /**
     * @generated from protobuf enum value: CAPABILITY_ACCOUNT_PROVISIONING = 5;
     */
    ACCOUNT_PROVISIONING = 5,
    /**
     * @generated from protobuf enum value: CAPABILITY_CREDENTIAL_ROTATION = 6;
     */
    CREDENTIAL_ROTATION = 6,
    /**
     * @generated from protobuf enum value: CAPABILITY_RESOURCE_CREATE = 7;
     */
    RESOURCE_CREATE = 7,
    /**
     * @generated from protobuf enum value: CAPABILITY_RESOURCE_DELETE = 8;
     */
    RESOURCE_DELETE = 8,
    /**
     * @generated from protobuf enum value: CAPABILITY_SYNC_SECRETS = 9;
     */
    SYNC_SECRETS = 9,
    /**
     * @generated from protobuf enum value: CAPABILITY_ACTIONS = 10;
     */
    ACTIONS = 10,
    /**
     * @generated from protobuf enum value: CAPABILITY_TARGETED_SYNC = 11;
     */
    TARGETED_SYNC = 11,
    /**
     * @generated from protobuf enum value: CAPABILITY_EVENT_FEED_V2 = 12;
     */
    EVENT_FEED_V2 = 12,
    /**
     * @generated from protobuf enum value: CAPABILITY_SERVICE_MODE_TARGETED_SYNC = 13;
     */
    SERVICE_MODE_TARGETED_SYNC = 13
}
/**
 * @generated from protobuf enum c1.connector.v2.CapabilityDetailCredentialOption
 */
export enum CapabilityDetailCredentialOption {
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_NO_PASSWORD = 1;
     */
    NO_PASSWORD = 1,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_RANDOM_PASSWORD = 2;
     */
    RANDOM_PASSWORD = 2,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_SSO = 3;
     */
    SSO = 3,
    /**
     * @generated from protobuf enum value: CAPABILITY_DETAIL_CREDENTIAL_OPTION_ENCRYPTED_PASSWORD = 4;
     */
    ENCRYPTED_PASSWORD = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCleanupRequest$Type extends MessageType<ConnectorServiceCleanupRequest> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceCleanupRequest", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 2, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceCleanupRequest
 */
export const ConnectorServiceCleanupRequest = new ConnectorServiceCleanupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceCleanupResponse$Type extends MessageType<ConnectorServiceCleanupResponse> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceCleanupResponse", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceCleanupResponse
 */
export const ConnectorServiceCleanupResponse = new ConnectorServiceCleanupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorMetadata$Type extends MessageType<ConnectorMetadata> {
    constructor() {
        super("c1.connector.v2.ConnectorMetadata", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", prefix: "https://", uri: true, ignoreEmpty: true } } } },
            { no: 3, name: "icon", kind: "message", T: () => AssetRef },
            { no: 4, name: "logo", kind: "message", T: () => AssetRef },
            { no: 5, name: "profile", kind: "message", T: () => Struct },
            { no: 6, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 8, name: "capabilities", kind: "message", T: () => ConnectorCapabilities },
            { no: 9, name: "account_creation_schema", kind: "message", T: () => ConnectorAccountCreationSchema }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorMetadata
 */
export const ConnectorMetadata = new ConnectorMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialDetails$Type extends MessageType<CredentialDetails> {
    constructor() {
        super("c1.connector.v2.CredentialDetails", [
            { no: 1, name: "capability_account_provisioning", kind: "message", T: () => CredentialDetailsAccountProvisioning },
            { no: 2, name: "capability_credential_rotation", kind: "message", T: () => CredentialDetailsCredentialRotation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialDetails
 */
export const CredentialDetails = new CredentialDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialDetailsAccountProvisioning$Type extends MessageType<CredentialDetailsAccountProvisioning> {
    constructor() {
        super("c1.connector.v2.CredentialDetailsAccountProvisioning", [
            { no: 1, name: "supported_credential_options", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] },
            { no: 2, name: "preferred_credential_option", kind: "enum", T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialDetailsAccountProvisioning
 */
export const CredentialDetailsAccountProvisioning = new CredentialDetailsAccountProvisioning$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialDetailsCredentialRotation$Type extends MessageType<CredentialDetailsCredentialRotation> {
    constructor() {
        super("c1.connector.v2.CredentialDetailsCredentialRotation", [
            { no: 1, name: "supported_credential_options", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] },
            { no: 2, name: "preferred_credential_option", kind: "enum", T: () => ["c1.connector.v2.CapabilityDetailCredentialOption", CapabilityDetailCredentialOption, "CAPABILITY_DETAIL_CREDENTIAL_OPTION_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialDetailsCredentialRotation
 */
export const CredentialDetailsCredentialRotation = new CredentialDetailsCredentialRotation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCapabilities$Type extends MessageType<ConnectorCapabilities> {
    constructor() {
        super("c1.connector.v2.ConnectorCapabilities", [
            { no: 1, name: "resource_type_capabilities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceTypeCapability },
            { no: 2, name: "connector_capabilities", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.Capability", Capability, "CAPABILITY_"] },
            { no: 3, name: "credential_details", kind: "message", T: () => CredentialDetails }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorCapabilities
 */
export const ConnectorCapabilities = new ConnectorCapabilities$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CapabilityPermission$Type extends MessageType<CapabilityPermission> {
    constructor() {
        super("c1.connector.v2.CapabilityPermission", [
            { no: 1, name: "permission", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CapabilityPermission
 */
export const CapabilityPermission = new CapabilityPermission$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CapabilityPermissions$Type extends MessageType<CapabilityPermissions> {
    constructor() {
        super("c1.connector.v2.CapabilityPermissions", [
            { no: 1, name: "permissions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CapabilityPermission }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CapabilityPermissions
 */
export const CapabilityPermissions = new CapabilityPermissions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeCapability$Type extends MessageType<ResourceTypeCapability> {
    constructor() {
        super("c1.connector.v2.ResourceTypeCapability", [
            { no: 1, name: "resource_type", kind: "message", T: () => ResourceType },
            { no: 2, name: "capabilities", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.Capability", Capability, "CAPABILITY_"] },
            { no: 3, name: "permissions", kind: "message", T: () => CapabilityPermissions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceTypeCapability
 */
export const ResourceTypeCapability = new ResourceTypeCapability$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetMetadataRequest$Type extends MessageType<ConnectorServiceGetMetadataRequest> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceGetMetadataRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceGetMetadataRequest
 */
export const ConnectorServiceGetMetadataRequest = new ConnectorServiceGetMetadataRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceGetMetadataResponse$Type extends MessageType<ConnectorServiceGetMetadataResponse> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceGetMetadataResponse", [
            { no: 1, name: "metadata", kind: "message", T: () => ConnectorMetadata }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceGetMetadataResponse
 */
export const ConnectorServiceGetMetadataResponse = new ConnectorServiceGetMetadataResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceValidateRequest$Type extends MessageType<ConnectorServiceValidateRequest> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceValidateRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceValidateRequest
 */
export const ConnectorServiceValidateRequest = new ConnectorServiceValidateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorServiceValidateResponse$Type extends MessageType<ConnectorServiceValidateResponse> {
    constructor() {
        super("c1.connector.v2.ConnectorServiceValidateResponse", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 2, name: "sdk_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorServiceValidateResponse
 */
export const ConnectorServiceValidateResponse = new ConnectorServiceValidateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema$Type extends MessageType<ConnectorAccountCreationSchema> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema", [
            { no: 1, name: "field_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema
 */
export const ConnectorAccountCreationSchema = new ConnectorAccountCreationSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_Field$Type extends MessageType<ConnectorAccountCreationSchema_Field> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.Field", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "deprecated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "string_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringField },
            { no: 101, name: "bool_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_BoolField },
            { no: 102, name: "string_list_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_StringListField },
            { no: 103, name: "int_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_IntField },
            { no: 104, name: "map_field", kind: "message", oneof: "field", T: () => ConnectorAccountCreationSchema_MapField }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.Field
 */
export const ConnectorAccountCreationSchema_Field = new ConnectorAccountCreationSchema_Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringField$Type extends MessageType<ConnectorAccountCreationSchema_StringField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.StringField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringField
 */
export const ConnectorAccountCreationSchema_StringField = new ConnectorAccountCreationSchema_StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_BoolField$Type extends MessageType<ConnectorAccountCreationSchema_BoolField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.BoolField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.BoolField
 */
export const ConnectorAccountCreationSchema_BoolField = new ConnectorAccountCreationSchema_BoolField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_StringListField$Type extends MessageType<ConnectorAccountCreationSchema_StringListField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.StringListField", [
            { no: 1, name: "default_value", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.StringListField
 */
export const ConnectorAccountCreationSchema_StringListField = new ConnectorAccountCreationSchema_StringListField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_IntField$Type extends MessageType<ConnectorAccountCreationSchema_IntField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.IntField", [
            { no: 1, name: "default_value", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.IntField
 */
export const ConnectorAccountCreationSchema_IntField = new ConnectorAccountCreationSchema_IntField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorAccountCreationSchema_MapField$Type extends MessageType<ConnectorAccountCreationSchema_MapField> {
    constructor() {
        super("c1.connector.v2.ConnectorAccountCreationSchema.MapField", [
            { no: 1, name: "default_value", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => ConnectorAccountCreationSchema_Field } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ConnectorAccountCreationSchema.MapField
 */
export const ConnectorAccountCreationSchema_MapField = new ConnectorAccountCreationSchema_MapField$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ConnectorService
 */
export const ConnectorService = new ServiceType("c1.connector.v2.ConnectorService", [
    { name: "GetMetadata", options: {}, I: ConnectorServiceGetMetadataRequest, O: ConnectorServiceGetMetadataResponse },
    { name: "Validate", options: {}, I: ConnectorServiceValidateRequest, O: ConnectorServiceValidateResponse },
    { name: "Cleanup", options: {}, I: ConnectorServiceCleanupRequest, O: ConnectorServiceCleanupResponse }
]);
